<div class="nav-scroller bg-secondary primary-nav-bar">
    <div #nav class="nav">
        <div class="nav-item">
            <a class="nav-link" routerLink="/overview" routerLinkActive="active">OVERVIEW</a>
        </div>
        <ng-template ngFor let-legalEntity [ngForOf]="user?.legalEntities" let-i="index">
            <div class="nav-item" *ngIf="legalEntity.ccrOrExpo === 1">
                <a class="nav-link" routerLink="/entitySummary/{{legalEntity.entityId}}"
                   [ngClass]="{ 'active': legalEntity.entityId == selectedEntityId }">{{ legalEntity.name }}</a>
            </div>
        </ng-template>
    </div>

    <div class="dropdown px-mr-110 entity-dropdown" *ngIf="user?.legalEntities" (mouseenter)="delayedDisplay(); setupLocations()" (mouseleave)="undisplay()">
        <button class="dropbtn">Other Entities &#9660;</button>
        <div class="dropdown-content" [style.visibility]="entityDropdownVisibility" >
            <a *ngFor="let entity of user?.legalEntities" [class.d-none]="!visible(entity.name)" routerLink="/entitySummary/{{entity.entityId}}">{{entity.name}}</a>
        </div>
    </div>
</div>

<div class="nav-scroller bg-secondary" *ngIf="showSecondaryMenu()">
    <ul class="nav d-flex">
        <li class="nav-item">
            <a class="nav-link" routerLink="/entitySummary/{{selectedEntityId}}" 
               routerLinkActive="active"
               [routerLinkActiveOptions]="{ exact: false, __change_detection_hack__: selectedEntityId}"
            >SUMMARY</a>
        </li>
        <li class="nav-item" *ngFor="let counterParty of counterParties;">
            <!--<a class="nav-link" [routerLink]="['counterPartyFuckYou/', selectedEntityId, counterParty]"-->
            <a class="nav-link" routerLink="/counterParty/{{selectedEntityId}}/{{counterParty}}"
               routerLinkActive="active">{{ counterParty }}</a>
        </li>
    </ul>
</div>
